import React from 'react';
import PropTypes from 'prop-types';
import cn from 'classnames';

import styles from './CompanyItem.module.scss';

export default function CompanyItem(props) {
  return (
    <div
      style={{ '--src': `url(${require('assets/464c29206bfe1bb853f0132ac6c4cf09.png')})` }}
      className={cn(styles.content_box, 'company-item')}>
      <div className={styles.content_box1}>
        <img src={require('assets/405f089da730513d6c9a7f583c0024a8.png')} alt="alt text" className={styles.image24} />
      </div>

      <div className={styles.flex_col}>
        <div className={styles.flex_col__cell}>
          <img src={props.image} alt="alt text" className={styles.image} />
        </div>
        <h4 className={styles.highlights}>{props.highlights}</h4>
      </div>
    </div>
  );
}

CompanyItem.propTypes = {
  image: PropTypes.string.isRequired,
  highlights: PropTypes.string.isRequired
};
